import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { overlaySidebarWrapperTheme } from '../../theme/default-theme';

interface IOverlaySidebar {
    isOverlayVisible: boolean;
    transition?: string;
}

interface IOverlaySidebarWrapper {
    isSidebarVisible: boolean;
    isOverlayVisible: boolean;
    transition?: string;
}

const sidebarMargin = '-1200px';

const AnimatedOverlaySidebarWrapper = styled.div<
    IOverlaySidebarWrapper & React.HTMLProps<HTMLDivElement>
>`
    position: fixed;
    width: auto;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    right: ${props => (props.isOverlayVisible ? '0' : sidebarMargin)};
    transition: ${({ transition }) => transition || '0.7s'};
    visibility: ${props => (props.isSidebarVisible ? 'visible' : 'hidden')};
    border-left-style: solid;
    border-left-width: 1px;
    z-index: 1000;
    text-align: left;
    ${overlaySidebarWrapperTheme}
`;

export class OverlaySidebar extends React.Component<IOverlaySidebar> {
    private isSidebarVisible: boolean;

    constructor(props: IOverlaySidebar) {
        super(props);
        this.isSidebarVisible = false;
    }

    public componentDidMount() {
        this.isSidebarVisible = true;
    }

    public render() {
        const overlaySidebarClass = classnames(
            'elc-overlay-sidebar',
            'js-overlay-sidebar',
            this.props.isOverlayVisible
                ? ['elc-overlay-sidebar-slidein', 'js-overlay-sidebar-slidein']
                : ['elc-overlay-sidebar-slideout', 'js-overlay-sidebar-slideout']
        );

        return (
            <AnimatedOverlaySidebarWrapper
                className={overlaySidebarClass}
                isOverlayVisible={this.props.isOverlayVisible}
                isSidebarVisible={this.isSidebarVisible}
                transition={this.props.transition}
            >
                {this.props.children}
            </AnimatedOverlaySidebarWrapper>
        );
    }
}
